<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Qioq78/tc-custom/9781644053393.jpg?1696092324258" alt="This image is the cover for the book String Boys"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">String Boys
      </h1>
      <p class="bookDescription body article font2">
        <p>Seth Arnold learned at an early age that two things in life could make his soul soar—his violin and Kelly Cruz. In Seth’s uncertain childhood, the kindness of the Cruz family, especially Kelly and his brother, Matty, gave Seth the stability to make his violin sing with the purest sound and opened a world of possibility beyond his home in Sacramento.</p> <p>Kelly Cruz has loved Seth forever, but he knows Seth’s talents shouldn’t be hidden, not when the world is waiting. Encouraging Seth to follow his music might break Kelly’s heart, but he is determined to see the violin set Seth’s soul free. When their world is devastated by a violent sexual assault and Matty’s prejudices turn him from a brother to an enemy, Seth and Kelly’s future becomes uncertain.</p> <p>Seth can’t come home and Kelly can’t leave, but they are held together by a love that they clutch with both hands.</p> <p>Seth and Kelly are young and the world is wide—the only thing they know for certain is they’ll follow their heartstrings to each other’s arms whenever time and fate allow. And pray that one day they can follow that string to forever… before it slices their hearts in two.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amy Lane
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?65eb6458